import React from "react";
import { withTranslation } from 'react-i18next';
import { withSnackbar } from 'notistack';
import {
    Grid,
    Card,
    CardContent,
    CircularProgress,
    Button,
    Stepper,
    Step,
    StepLabel,
    Typography,
    FormControl,
    InputLabel,
    InputAdornment,
    IconButton,
    OutlinedInput,
    CardHeader,
    makeStyles
} from "@material-ui/core";
import GetAppIcon from '@material-ui/icons/GetApp';
import FileIcon from "@material-ui/icons/InsertDriveFile";
import { getSpecificClients } from "views/clients/api/apiClients";
import SelectClient from "common/components/custom/SelectClient";
import { handleUploadFileAsset } from "../api/apiImport";
import { getInventorySimple } from "../../inventory/api/apiInventory"
import SelectInventory from "common/components/custom/SelectInventory";
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import CheckIcon from '@material-ui/icons/Check';
import NotificationImportantIcon from '@material-ui/icons/NotificationImportant';
import clsx from 'clsx';
import ValidationDialog from "./ValidationDialog";
import ExampleTemplate from '../../../assets/template/asset_template.xlsx'

const useStyles = makeStyles(() => ({
    root: {
        backgroundColor: '#eaeaf0',
        padding: 8,
        borderRadius: '50%'
    },
    active: {
        color: 'grey',
    },
    completed: {
        color: 'green',
    },
}));

class ImportAssets extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            activeStep: 0,
            fileName: null,
            selectedClient: null,
            specificsClients: [],
            fileData: null,
            stepFailed: false,
            responseData: {},
            selectedInventory: null,
            inventories: [],
            isLoadingImport: false,
            openContinueDialog: false
        };
    }

    async componentDidMount() {
        this.getSpecificClients()
    }

    getSpecificClients = () => {
        getSpecificClients().then((response) => {
            let selectedClient = response.data.data.length > 0 ? response.data.data[0] : null
            this.setState({ specificsClients: response.data.data, selectedClient: selectedClient }, selectedClient ? this.getInventorySimple(selectedClient.id) : null);
        }).catch(error => {
            this.props.enqueueSnackbar(this.props.t("something_went_wrong"), { variant: 'error' });
        });
    }

    getInventorySimple = (selectedClient) => {
        getInventorySimple(selectedClient).then((response) => {
            this.setState({ inventories: response.data.data });
        }).catch(error => {
            this.props.enqueueSnackbar(this.props.t("something_went_wrong"), { variant: 'error' });
        });
    }

    getStepContent = (stepIndex) => {
        switch (stepIndex) {
            case 0:
                return this.props.t("select_asset_file");
            default:
                return this.props.t("");
        }
    }

    handleNext = () => {
        this.setState({ activeStep: this.state.activeStep + 1 })
    };

    handleBack = () => {
        this.setState({ activeStep: this.state.activeStep - 1 })
    };

    handleReset = () => {
        this.setState({ activeStep: 0 })
    };

    isStepFailed = () => {
        let { activeStep, stepFailed } = this.state
        return activeStep === 3 && stepFailed ? activeStep === 3 : activeStep === -1;
    };

    handleChangeClient = (client) => {
        if (client !== null) {
            this.setState({ selectedClient: client }, () => this.getInventorySimple(client.id))
        } else {
            this.setState({ selectedClient: null, selectedInventory: null, fileName: '' })
        }
    }

    handleChangeInventory = (inventory) => {
        if (inventory !== null) {
            this.setState({ selectedInventory: inventory })
        } else {
            this.setState({ selectedInventory: null })
        }
    }

    handleChangeFile = (e) => {
        let file = e.target.files[0];
        if (!file) {
            return;
        }
        const data = new FormData()
        data.append('file', file)
        this.setState({ fileName: file.name, fileData: data, activeStep: 1 })
    }

    importFile = () => {
        this.setState({ isLoadingImport: true, activeStep: 2 })
        this.handleUploadFile(false)
    }

    handleUploadFile = (skipValidation) => {
        handleUploadFileAsset({ params: { inventoryId: this.state.selectedInventory.id, skipValidation: skipValidation } }, this.state.fileData).then(response => {
            this.setState({ responseData: response.data.data, openContinueDialog: skipValidation === true ? false : true })
            if (skipValidation === true) {
                this.setState({ activeStep: 3, isLoadingImport: false, fileName: null })
                this.props.enqueueSnackbar(this.props.t("success_import"), { variant: 'success' });
            }

        }).catch(error => {
            if (error.response.status === 400) {
                this.setState({ activeStep: 3, stepFailed: true, responseData: error.response.data.data })
            }
            this.setState({ isLoadingImport: false })
            this.props.enqueueSnackbar(this.props.t("import_failed"), { variant: 'error' });
        })
    }

    render() {

        let { isLoading, activeStep, fileName, specificsClients, selectedClient, responseData, inventories, selectedInventory, isLoadingImport } = this.state;

        let steps = [this.props.t("select_file"), this.props.t("processing_data"), this.props.t("processing_finished")]

        if (isLoading) {
            return (
                <div className="loading-position">
                    <CircularProgress className="spinner" color="primary" />
                </div>
            )
        }

        const CustomStepIcon = (props) => {
            const classes = useStyles();
            const { active, completed } = props;

            const stepIcons = {
                1: <InsertDriveFileIcon />,
                2: <NotificationImportantIcon />,
                3: <CheckIcon />,
            };

            return (
                <div className={clsx(classes.root, {
                    [classes.active]: active,
                    [classes.completed]: completed,
                })}>
                    {stepIcons[String(props.icon)]}
                </div>
            );
        };

        return <Grid container direction="row" spacing={2}>
            <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                <Card>
                    <CardContent>
                        <Grid container direction="row" spacing={2}>
                            <Grid item container direction="column" xs={2} sm={2} md={2} lg={2} xl={2}>
                                <Grid container direction="row" spacing={2}>
                                    <SelectClient
                                        specificsClients={specificsClients}
                                        selectedClient={selectedClient}
                                        handleChange={this.handleChangeClient}
                                    />
                                </Grid>
                            </Grid>
                            {selectedClient !== null && <Grid item container direction="column" xs={3} sm={3} md={3} lg={3} xl={3}>
                                <Grid item container>
                                    <SelectInventory
                                        inventories={inventories}
                                        selectedInventory={selectedInventory}
                                        handleChange={this.handleChangeInventory}
                                    />
                                </Grid>
                            </Grid>}
                        </Grid>
                        <br />
                        {selectedClient !== null && <><Stepper activeStep={activeStep} alternativeLabel>
                            {steps.map((label, index) => {
                                const stepProps = {};
                                const labelProps = {};
                                if (this.isStepFailed(index)) {
                                    if (label === this.props.t("processing_finished") && this.state.stepFailed) {
                                        labelProps.error = true;
                                    }
                                }
                                return (
                                    <Step key={label} {...stepProps}>
                                        <StepLabel StepIconComponent={CustomStepIcon} {...labelProps}>{label}</StepLabel>
                                    </Step>
                                );
                            })}
                        </Stepper>
                            <Grid container direction="row" spacing={2}>
                                <Grid item container direction="column" xs={6} sm={6} md={5} lg={4} xl={3}>
                                    <Typography>{this.getStepContent(activeStep)}</Typography>
                                    <input
                                        disabled={!selectedClient}
                                        style={{ display: 'none' }}
                                        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                        id="powerSystemModelFile"
                                        name="powerSystemModel"
                                        type="file"
                                        onChange={(e) => { this.handleChangeFile(e); this.setState(() => e.target.value = null) }}
                                    />
                                    <FormControl fullWidth variant="outlined">
                                        <InputLabel id="fileName" margin="dense" >{fileName ? this.props.t("selected_xlsx_file") : this.props.t("select_xlsx_file")}</InputLabel>
                                        <OutlinedInput
                                            labelid="fileName"
                                            label={fileName ? this.props.t("selected_xlsx_file") : this.props.t("select_xlsx_file")}
                                            id="fileName"
                                            name="fileName"
                                            disabled={true}
                                            value={fileName || ''}
                                            margin="dense"
                                            size="small"
                                            variant="outlined"
                                            endAdornment={
                                                <InputAdornment position="end">
                                                    <label htmlFor="powerSystemModelFile">
                                                        <IconButton
                                                            component="span"
                                                            edge="end"
                                                        >
                                                            <FileIcon />
                                                        </IconButton>
                                                    </label>
                                                </InputAdornment>
                                            }
                                            labelWidth={70}
                                        />
                                    </FormControl>
                                    <br />
                                    {fileName && selectedInventory !== null && <Grid item container direction="column" xs={6} sm={6} md={5} lg={4} xl={3}>
                                        <Button style={{ width: '131px', height: '40px' }} variant="contained" color="primary" disabled={isLoadingImport} onClick={() => this.importFile()}>
                                            {isLoadingImport ? <CircularProgress
                                                size={20}
                                                color="secondary"
                                            /> : this.props.t("submit")}
                                        </Button>
                                    </Grid>}
                                </Grid>
                            </Grid></>}
                    </CardContent>
                </Card>
                <br />
                <Grid container direction="row" spacing={2}>
                    <Grid item container direction="column" xs={8} sm={8} md={8} lg={5} xl={5}>
                        <Card>
                            <CardHeader
                                title={this.props.t("excel_example")}
                            />
                            <CardContent>
                                <a href={ExampleTemplate} download="ImportAssetTemplate" target='_blank' rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                                    <Button variant="contained" color="secondary" aria-label="edit" style={{ top: '4px' }}><GetAppIcon />{this.props.t("template")}</Button>
                                </a>
                                <p>{this.props.t("excel_example_row1")}</p>
                                <p>{this.props.t("excel_example_row4")}</p>
                            </CardContent>
                        </Card>
                    </Grid>
                    {Object.keys(responseData).length > 0 && activeStep === 3 && <Grid item container direction="column" xs={4} sm={4} md={4} lg={5} xl={4}>
                        <Card>
                            <CardContent style={{ backgroundColor: '#c1f7c1' }}>
                                <p><span><b>{this.props.t("file_name")}: </b></span><span>{responseData && responseData.fileName}</span></p>
                                <p><span><b>{this.props.t("file_extension")}: </b></span> <span>{responseData && responseData.fileExtension}</span></p>
                                <p><span><b>{this.props.t("worksheet_name")}: </b></span><span>{responseData && responseData.worksheetName}</span></p>
                                <p><span><b>{this.props.t("number_of_rows")}: </b></span><span>{responseData && responseData.numberOfRows}</span></p>
                                <p><span><b>{this.props.t("number_of_empty_rows")}: </b></span><span>{responseData && responseData.numberOfEmptyRows}</span></p>
                                <p><span><b>{this.props.t("number_of_invalid_rows")}: </b></span><span>{responseData.invalidRows && Object.keys(responseData.invalidRows).length}</span></p>
                            </CardContent>
                        </Card>
                    </Grid>}
                </Grid>
                <ValidationDialog
                    isOpen={this.state.openContinueDialog}
                    title={this.props.t("validation")}
                    onClose={() => this.setState({ openContinueDialog: false, isLoadingImport: false, activeStep: 1 })}
                    onConfirm={() => this.setState({ openContinueDialog: false }, () => this.handleUploadFile(true))}
                    closeButtonTitle={this.props.t("cancel")}
                    confirmButtonTitle={this.props.t("skip_validation")}
                    responseData={responseData}
                />
            </Grid>
        </Grid>
    }
}

export default withSnackbar(withTranslation()(ImportAssets))